import { Component, ViewEncapsulation, OnDestroy, HostListener } from '@angular/core';
import { DragulaService } from 'ng2-dragula';

@Component({
  selector: 'swb-root',
  templateUrl: './app.component.html',
  styleUrls: ['../../node_modules/dragula/dist/dragula.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnDestroy {

  @HostListener('dragenter', ['$event'])
  onDragEnter(event) {
    event.preventDefault();
  }

  constructor(private _dragulaService: DragulaService) {
    const options: any = {
      moves: (el, container, handle) => {
        return handle.className === 'widget__header';
      }
    };

    _dragulaService.createGroup('widget-bag', options);
    window.addEventListener('touchmove', function () { });
  }

  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this._dragulaService.destroy('widget-bag');
  }
}

